import React, { useEffect, useState } from 'react';
import { createTimesegment, deleteTimesegment, getSiteTimesegments, updateTimesegment } from '../../api';
import Timesegment from './Timesegment';
import produce from 'immer';
import nanoid from 'nanoid';
import { IconButton, makeStyles, Typography } from '@material-ui/core';
import { Add as AddIcon } from '@material-ui/icons';
import SubmitButtons from '../SubmitButtons';


const useStyles = makeStyles(theme => ({
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: theme.spacing(3)
  },
  footer: {
    textAlign: 'right'
  },
  button: {
    marginLeft: theme.spacing(2)
  }
}));


/**
 * Display Timesegments
 * @param {site, onComplete} props 
 */
function Timesegments(props) {
  const { site, onComplete } = props;

  const classes = useStyles();
  const [timesegments, setTimesegments] = useState([]);

  const addTimesegment = () => {
    setTimesegments(produce(draftState => {
      draftState.push({
        id: nanoid(),
        days: [],
        startTime: '07:00:00',
        endTime: '18:00:00',
        interval: 30,
        site: site.id,
        action: 'CREATE'
      });
      return draftState;
    }));
  }

  const editTimesegment = (id, key, val) => {
    setTimesegments(produce(draftState => {
      var idx = timesegments.findIndex(el => el.id === id);
      if (idx < 0) return;

      switch (key) {
        case 'days':
          const dayIdx = timesegments[idx].days.indexOf(val);
          if (dayIdx > -1) draftState[idx].days.splice(dayIdx, 1);
          else draftState[idx].days.push(val);
          break;
      
        default:
          draftState[idx][key] = val;
      }

      if (!draftState[idx].action) draftState[idx].action = 'UPDATE';

      return draftState;
    }));
  }

  const removeTimesegment = (id) => {
    setTimesegments(produce(draftState => {
      var idx = timesegments.findIndex(el => el.id === id);
      if (idx < 0) return;

      if (draftState[idx].action === 'CREATE') {
        // Remove if just created
        draftState.splice(idx, 1);
      } else {
        // Set action to remove if it already existed
        draftState[idx].action = 'REMOVE';
      }

      return draftState;
    }));
  }

  const saveTimesegments = () => {
    timesegments.forEach(ts => {
      var { id, action, ...data } = ts;
      switch (action) {
        case 'CREATE':
          createTimesegment(data);
          break;
        
        case 'UPDATE':
          updateTimesegment(id, data);
          break;
        
        case 'REMOVE':
          deleteTimesegment(id);
          break;
      
        default:
          break;
      }
    });

    if (onComplete) onComplete();
  }



  useEffect(() => {
    getSiteTimesegments(site.id)
      .then(res => setTimesegments(res))
      .catch(err => console.log(err));
  }, [site]);



  return (
    <div>
      <div className={classes.header}>
        <Typography variant='h5'>Timesegments</Typography>

        <IconButton onClick={addTimesegment}>
          <AddIcon />
        </IconButton>
      </div>

      <div>
        {timesegments
          .filter(ts => ts.action !== 'REMOVE')
          .map((ts, idx) => {
            return (
              <Timesegment
                key={ts.id}
                title={idx}
                data={ts}
                edit={(key, val) => editTimesegment(ts.id, key, val)}
                remove={() => removeTimesegment(ts.id)}
              />
            );
          })}
      </div>

      <SubmitButtons
        onSubmit={saveTimesegments}
        onCancel={onComplete ? onComplete : null}
      />
    </div>
  );
}

export default Timesegments;
